import { Component, OnDestroy, OnInit } from '@angular/core';
import { SEOService } from '../../../common/SEOService';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { getWindow } from 'ssr-window';

@Component({
  selector: 'app-seo',
  template: ''
})
export class SeoComponent implements OnInit, OnDestroy {
  private jsonLdId = 'delivery-area-jsonld';

  constructor(private seo: SEOService, private appConfig: AppConfigService) {}

  ngOnInit(): void {
    try {
      const base = (this.appConfig && this.appConfig.setting && this.appConfig.setting.webUrl)
        ? this.appConfig.setting.webUrl.replace(/\/$/, '')
        : (typeof window !== 'undefined' ? getWindow().location.origin : 'https://1bakeshop.com');

      const jsonLd = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "1 Bake Shop",
        "url": base,
        "description": "Online bakery delivering fresh cakes, cookies and more across Odisha, India. We accept online orders and deliver to multiple cities including Bhubaneswar, Cuttack, Puri and Bhadrak.",
        "areaServed": [
          { "@type": "State", "name": "Odisha" },
          { "@type": "City", "name": "Bhubaneswar" },
          { "@type": "City", "name": "Cuttack" },
          { "@type": "City", "name": "Puri" },
          { "@type": "City", "name": "Bhadrak" }
        ],
        "service": {
          "@type": "Service",
          "name": "Online Order & Delivery",
          "serviceType": "Online Order and Home Delivery",
          "areaServed": ["Odisha", "Bhubaneswar", "Cuttack", "Puri", "Bhadrak"]
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Product Categories",
          "itemListElement": [
            { "@type": "OfferCatalog", "name": "Customized Cakes", "url": base + "/customized-product" },
            { "@type": "OfferCatalog", "name": "Birthday Cakes", "url": base + "/cake-catalogue?category=birthday" },
            { "@type": "OfferCatalog", "name": "Occasion Cakes", "url": base + "/cake-catalogue?category=occasion" },
            { "@type": "OfferCatalog", "name": "Special Cakes", "url": base + "/cake-catalogue?category=special" },
            { "@type": "OfferCatalog", "name": "Photo Frames", "url": base + "/customized-product#photoFrames" },
            { "@type": "OfferCatalog", "name": "Chocolates", "url": base + "/products?category=chocolates" }
          ]
        },
        "sameAs": [
          "https://www.facebook.com/1bakeshop",
          "https://www.instagram.com/1bakeshop"
        ]
      };

      this.seo.addJSONLD(jsonLd, this.jsonLdId);
    } catch (e) {
      // ignore on server or if DOM unavailable
    }
  }

  ngOnDestroy(): void {
    try {
      this.seo.removeTagBySelector(`script[type='application/ld+json'][data-id='${this.jsonLdId}']`);
    } catch (e) {}
  }
}
